<p-dialog
	header="{{this.translateServ.dictionary['NOTIFICATIONS']}}"
	[(visible)]="visible"
	[modal]="true"
	appendTo="body"
	[keepInViewport]="true"
	[style]="{width: '800px', minHeight: '400px'}"
	(onHide)="close()"
>
	<ng-container *ngIf="isNotificationsLoading">
		<p-progressBar mode="indeterminate"></p-progressBar>
		<div class="p-mt-3 p-text-center">{{this.translateServ.dictionary['LOADING_NOTIFICATIONS']}}...</div>
	</ng-container>
	<ng-container *ngIf="!isNotificationsLoading && notificationsData.length === 0">
		<div class="p-text-center p-mt-3">{{this.translateServ.dictionary['NO_NOTIF_FOUND']}}</div>
	</ng-container>
	<ng-container *ngIf="!isNotificationsLoading && notificationsData.length > 0">
		<p-table [value]="notificationsData" [responsiveLayout]="'scroll'" [style]="{width: '100%'}">
			<ng-template pTemplate="header">
				<tr>
					<th style="width: 2rem;">#</th>
					<th>{{this.translateServ.dictionary['FILE_TYPE']}}</th>
					<th>{{this.translateServ.dictionary['NOTIFICATION_DETAIL']}}</th>
					<th>{{this.translateServ.dictionary['NOTIFICATION_DATE']}}</th>
					<th style="width: 7rem; text-align: center;">
						<p-checkbox [binary]="true" [ngModel]="areAllNotificationsResolved()" [disabled]="!isAllowedToChange || isAnyNotificationUpdateInProgress()" (ngModelChange)="onResolveAllNotificationsChange($event)" />
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-row let-i="rowIndex">
				<tr [class.notification-resolved-row]="row.IsNotificationResolved === 1">
					<td>{{ i + 1 }}</td>
					<td>
						<span [ngStyle]="{'font-weight':'bold', 'color': row.ColorNotification}">{{ row.Name1 }}</span>
					</td>
					<td>
						<p-tag [value]="row.Name" [severity]="getNotificationDetailSeverity(row.ColorNotification)" />
					</td>
					<td>{{ row.DateEntered | date:'dd/MM/yyyy HH:mm' }}</td>
					<td style="text-align: center;">
						<p-checkbox [binary]="true" [ngModel]="row.IsNotificationResolved === 1" [disabled]="!isAllowedToChange || isNotificationUpdateInProgress(row)" (ngModelChange)="onNotificationCheckboxChange(row, $event)" />
					</td>
				</tr>
			</ng-template>
		</p-table>
	</ng-container>
</p-dialog>
